export default [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home')
  },
  {
    path: '/pdf',
    name: 'PdfHome',
    component: () => import('@/views/PdfHome')
  },
  {
    path: '/video',
    name: 'videoHome',
    component: () => import('@/views/VideoHome')
  },
  {
    path: '/upgrade-client',
    name: 'upgrade-client',
    component: () => import('@/components/UpgradeClient')
  }
]
